module.exports = __webpack_public_path__ + "img/poi_icon_foursquare.135d6c3.png";